import { render } from "./ReportsTableSkeleton.vue?vue&type=template&id=9308ff58"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__